import { FeeQuoteService } from './fee-quote.api';

export const FEE_QUOTE_API_PROVIDERS = [FeeQuoteService];

export * from './fee-quote.api';
